import { SvgIcon, useText } from "@sveabank/cc-common";
import { NavLink } from "react-router";
import type { NavPage } from "../../../types/navigation";
import NavButton from "./navButton";
import NavCircle from "./navCircle";
import NavLabel from "./navLabel";

const NavigationStep: React.FC<NavPage> = ({
	label,
	url,
	isCompleted,
	isActive,
	isAvailable,
	hasWarning,
	locked,
	totalSteps,
	stepNumber,
}: NavPage) => {
	const [t, texts] = useText();
	const activeText = t(
		texts.navbar.navItem.stepPresentation,
		stepNumber.toString(),
		totalSteps.toString(),
	);

	const Wrapper = isAvailable && !isActive ? NavLink : "div";

	const svg = locked ? (
		<SvgIcon className="text-foreground-success" imageSrc="LOCKED" height={14} />
	) : hasWarning ? (
		<SvgIcon className="text-foreground-alert" imageSrc="ALERT_EXCLAMATION" />
	) : isCompleted ? (
		<SvgIcon className="text-foreground-success" imageSrc="CHECK" height={10} />
	) : undefined;

	const circleBorderColor = locked
		? "border-transparent"
		: hasWarning
			? "border-foreground-alert"
			: isCompleted
				? "border-transparent"
				: "border-interactive-primary";

	const circleBackgroundColor = locked
		? "bg-background-success"
		: hasWarning
			? "bg-background-alert"
			: isCompleted
				? "bg-background-success"
				: "bg-transparent";

	const size = !locked && !isCompleted && !hasWarning ? "small" : "large";

	return (
		<Wrapper className="flex flex-col items-center justify-between" to={url}>
			{isActive ? (
				<NavButton hasWarning={hasWarning} buttonLabel={label} />
			) : (
				<NavCircle size={size} background={circleBackgroundColor} borderColor={circleBorderColor}>
					{svg}
				</NavCircle>
			)}
			<NavLabel isActive={isActive} activeText={activeText} inactiveText={label} />
		</Wrapper>
	);
};

export default NavigationStep;
